import * as Sentry from '@sentry/react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { styles } from './styles';

export const SentryErrorFallBack: Sentry.FallbackRender = ({ error, eventId, resetError }) => {
  const errorMessage = error instanceof Error ? error.message : 'Невідома помилка';

  return (
    <Box sx={styles.overlay}>
      <Paper sx={styles.card}>
        <Typography variant="h5" sx={{ mb: 1.5 }}>
          Неочікувана помилка програми
        </Typography>

        <Typography sx={{ lineHeight: 1.6, mb: 1 }}>
          Помилку вже зафіксовано в Sentry. Ви можете повторити спробу або надіслати звіт.
        </Typography>

        <Typography sx={styles.errorText}>{errorMessage}</Typography>

        {!!eventId && <Typography sx={styles.eventId}>Event ID: {eventId}</Typography>}

        <Box sx={styles.actions}>
          <Button variant="contained" onClick={resetError}>
            Повторіть спробу
          </Button>

          <Button
            variant="outlined"
            onClick={() => {
              eventId && Sentry.showReportDialog({ eventId });
            }}
          >
            Відправити звіт
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};
